<template>
    <div class="step-general-data">
        <v-card outlined class="step-card">
            <v-card-title class="step-card__title">
                {{ $t('surveys.wizard.generalData.cardTitle') }}
            </v-card-title>
            <v-card-subtitle class="step-card__subtitle">
                {{ $t('surveys.wizard.generalData.cardSubtitle') }}
            </v-card-subtitle>

            <v-card-text>
                <v-form ref="generalForm">
                    <v-text-field
                        v-model="localForm.title"
                        :label="$t('surveys.wizard.generalData.name')"
                        :placeholder="$t('surveys.wizard.generalData.namePlaceholder')"
                        outlined
                        dense
                        :rules="[rules.required]"
                        :readonly="readonly"
                        @input="emitUpdate"
                    ></v-text-field>

                    <v-textarea
                        v-model="localForm.description"
                        :label="$t('surveys.wizard.generalData.description')"
                        :placeholder="$t('surveys.wizard.generalData.descriptionPlaceholder')"
                        outlined
                        dense
                        rows="3"
                        :readonly="readonly"
                        @input="emitUpdate"
                    ></v-textarea>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="localForm.validFrom"
                                :label="$t('surveys.wizard.generalData.startDate')"
                                type="datetime-local"
                                outlined
                                dense
                                :readonly="readonly"
                                :rules="startDateRules"
                                @input="emitUpdate"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="localForm.validUntil"
                                :label="$t('surveys.wizard.generalData.endDate')"
                                type="datetime-local"
                                outlined
                                dense
                                :readonly="readonly"
                                :rules="endDateRules"
                                @input="emitUpdate"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "StepGeneralData",
    props: {
        form: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            localForm: {
                title: this.form.title || "",
                description: this.form.description || "",
                validFrom: this.formatDateTime(this.form.validFrom),
                validUntil: this.formatDateTime(this.form.validUntil)
            },
            rules: {
                required: value => !!value || this.$t('surveys.wizard.generalData.required')
            }
        };
    },

    watch: {
        form: {
            handler(newVal) {
                this.localForm.title = newVal.title || "";
                this.localForm.description = newVal.description || "";
                this.localForm.validFrom = this.formatDateTime(newVal.validFrom);
                this.localForm.validUntil = this.formatDateTime(newVal.validUntil);
            },
            deep: true
        }
    },

    computed: {
        startDateRules() {
            return [
                this.rules.required,
                value => {
                    if (!value) return true;
                    const now = new Date();
                    return new Date(value) >= now || this.$t('surveys.wizard.generalData.startDateError');
                }
            ];
        },
        endDateRules() {
            return [
                this.rules.required,
                value => {
                    if (!value) return true;
                    const now = new Date();
                    if (new Date(value) < now) return this.$t('surveys.wizard.generalData.endDatePastError');
                    if (this.localForm.validFrom && new Date(value) <= new Date(this.localForm.validFrom)) {
                        return this.$t('surveys.wizard.generalData.endDateError');
                    }
                    return true;
                }
            ];
        }
    },

    methods: {
        formatDateTime(value) {
            if (!value) return null;
            return value.length > 16 ? value.slice(0, 16) : value;
        },

        emitUpdate() {
            this.$emit('update', { ...this.localForm });
        }
    }
};
</script>

<style lang="css" scoped>
    .step-general-data {
        width: 100%;
        max-width: 100%;
    }

    .step-card {
        border-radius: 16px !important;
        padding: 8px;
        width: 100%;
    }

    .step-card__title {
        font-size: 15px !important;
        font-weight: 700 !important;
        color: var(--v-primary-base);
    }

    .step-card__subtitle {
        font-size: 12px !important;
        color: #9A9AA6;
    }
</style>
